import { useSocketMessage } from '@/composables/domains/chat/socket/useSocketMessage';
import { InboundMessageLD, InboundMessageTR } from '@/types/socket/inbound';
import { ChatMessageState, MessageHandlerMap } from '@/types/socket/message';
import { OutboundMessageCC } from '@/types/socket/outbound';
import { MIC_ADVANCED_OPTIONS } from '@/utils/constants/microphone';
import { getBrowserAndDeviceInfo } from '@/utils/device';

export const getInitialConnectionInfoTemplate = (): OutboundMessageCC => ({
  userId: '',
  isRegister: '0',
  isTssOn: '0',
  voiceId: '0',
  chatId: '',
  languageCode: 'ko',
  nickname: '',
  isPartnerPerson: '0',
  longVoice: '0',
  code: '',
  token: '',
  evictMySelf: '1',
  callType: 'GENERAL',
  connectionType: 'GENERAL', // 연결타입
  agent: JSON.stringify(getBrowserAndDeviceInfo()),
});

export const INITIAL_MESSAGE_TEMPLATE: InboundMessageTR = {
  dataFlag: '',
  languageCode: 'ko',
  sentAt: '',
  chatId: '',
  senderId: '',
  chatLogId: '',
  chatSubId: '',
  status: 'SENTENCE_COMPLETED',
  completeText: '',
  incompleteText: '',
  voiceKey: '',
  isFastInterpretationOn: '0',
} as const;

export const INITIAL_STATUS: ChatMessageState = {
  selectedChatId: '', // 현재 chatID
  interpretationSpeed: 'NORMAL', // 통역 속도
  voiceStatus: 'PENDING', // 음성 상태
  remainingMinutes: 0, // 잔여 시간
  isSingleLanguage: false, // 단일언어여부
  exceededUsageLimit: false, // 통화량 여부
  isFastInterpretation: false, // 빠른 통역 여부

  isGuestMicMuted: false, // 게스트 마이크
  isMutedByEmployee: false, //
  muteSenderId: '', //

  languageDetected: {} as InboundMessageLD, // 감지언어
  micAdvancedOptions: MIC_ADVANCED_OPTIONS, // 마이크 고급 설정
  attendees: {}, // 참가자목록
  isSocketReady: false, // TODO - 추후 SocketState를 사용할 수 있도록 변경해야함
  attendees: [], // 참가자목록

  micTimer: null, // 마이크 타이머
  systemAudioMicTimer: null, // 시스템 오디오 마이크 타이머
  isMicActivated: false,
} as const;

export const NO_EVENT_FLAGS = ['sw', 'pi', 'tc'];
export const SKIP_PARSING_FLAGS = ['sw', 'pi', 'tc', 'ue', 'td', 'nd', 'rc', 'rm', 'va', 'ta'];

export const MESSAGE_HEADER_LENGTH = 10;
export const FLAG_LENGTH = 2;

export const getChatMessageHandlers = (): MessageHandlerMap => {
  const message = useSocketMessage();
  return {
    ue: () => message.handleMessageUE(),
    rm: () => message.handleMessageRM(),
    va: () => message.handleMessageVA(),
    ta: () => message.handleMessageTA(),
    sl: (msg) => message.handleMessageSL(msg),
    em: (msg) => message.handleMessageEM(msg),
    al: (msg) => message.handleMessageAL(msg),
    ca: (msg) => message.handleMessageCA(msg),
    at: (msg) => message.handleMessageAT(msg),
    ld: (msg) => message.handleMessageLD(msg),
    cd: (msg) => message.handleMessageCD(msg),
    vc: (msg) => message.handleMessageVC(msg),
    cn: (msg) => message.handleMessageCN(msg),
    ut: (msg) => message.handleMessageUT(msg),
    fp: (msg) => message.handleMessageFP(msg),
    cc: (msg) => message.handleMessageCC(msg),
    am: (msg) => message.handleMessageAM(msg),
    fi: (msg) => message.handleMessageFI(msg),
    er: (msg) => message.handleMessageER(msg),
    fc: (msg) => message.handleMessageFC(msg),
    ep: (msg) => message.handleMessageEP(msg),
    tr: (msg) => message.handleMessageTR(msg),
    mt: (msg) => message.handleMessageMT(msg),
    dm: (msg) => message.handleMessageDM(msg),
    mm: (msg) => message.handleMessageMM(msg),
  };
};
